<template>
  <div class="container">
    <Loading v-if="pageLoading" />
    <div class="header">
      <p>ADMIN DASHBOARD</p>
      <div class="buttons">
        <div class="view">
          <button @click.prevent="usersButton">
            USERS
          </button>
        </div>
        <div class="view">
          <button @click.prevent="ordersButton">ORDERS</button>
        </div>
        <div class="view">
          <button @click.prevent="restaurantsButton">RESTAURANTS</button>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="data">
        <div class="users" v-if="showUsers">
          USERS
          <div class="users-top-bar">
            <div class="user-id">User ID</div>
            <div class="full-name">Full Name</div>
            <div class="username">Username</div>
            <div class="email">Email</div>
            <div class="phone-number">Phone Number</div>
          </div>
          <UserAdminView
            v-for="(userDetails, index) in users"
            :key="index"
            :userDetails="userDetails"
          />
        </div>
        <div class="orders" v-if="showOrders">
          ORDERS
          <div class="orders-top-bar">
            <div class="order-id">Order ID</div>
            <div class="full-name">Full Name</div>
            <div class="restaurant-name">Restaurant Name</div>
            <div class="time">Time</div>
            <div class="price">Price</div>
            <div class="saviour-name">Saviour Name</div>
            <div class="order-status">Status</div>
          </div>
          <OrderAdminView
            v-for="(orderDetails, index) in orders"
            :key="index"
            :orderDetails="orderDetails"
          />
        </div>
        <div class="restaurants" v-if="showRestaurants">
          RESTAURANTS
          <div class="restaurants-top-bar">
            <div class="restaurant-id">Restaurant ID</div>
            <div class="restaurant-name">Restaurant Name</div>
            <div class="restaurant-location">Restaurant Location</div>
          </div>
          <RestaurantAdminView
            v-for="(restaurantDetails, index) in restaurants"
            :key="index"
            :restaurantDetails="restaurantDetails"
          />
        </div>
      </div>
      <div class="load-more">
        <button @click.prevent="loadMoreDetails">Load More...</button>
      </div>
    </div>
  </div>
</template>

<script>
import UserAdminView from "../components/UserAdminView.vue";
import OrderAdminView from "../components/OrderAdminView.vue";
import RestaurantAdminView from "../components/RestaurantAdminView.vue";
import Loading from "../components/Loading.vue";
import db from "../firebase/firebaseInit";

export default {
  name: "AdminView",
  components: {
    UserAdminView,
    OrderAdminView,
    RestaurantAdminView,
    Loading,
  },
  data() {
    return {
      showUsers: true,
      showOrders: false,
      showRestaurants: false,
      users: [],
      lastUserLoaded: null,
      orders: [],
      lastOrderLoaded: null,
      restaurants: [],
      lastRestaurantLoaded: null,
      pageLoading: true,
    };
  },
  methods: {
    usersButton() {
      this.showUsers = true;
      this.showOrders = false;
      this.showRestaurants = false;
    },
    ordersButton() {
      this.showUsers = false;
      this.showOrders = true;
      this.showRestaurants = false;
    },
    restaurantsButton() {
      this.showUsers = false;
      this.showOrders = false;
      this.showRestaurants = true;
    },
    async loadMoreDetails() {
      if (this.showUsers) {
        const dataBase = await db
          .collection("users")
          .orderBy("firstName")
          .startAfter(this.lastUserLoaded)
          .limit(15);

        const dataBaseResultsUser = await dataBase.get();
        dataBaseResultsUser.docs.forEach((user) => {
          const userData = user.data();
          const userCredentials = {
            id: user.id,
            name: userData.firstName + " " + userData.lastName,
            username: userData.username,
            email: userData.email,
            phoneNumber: userData.phoneNumber,
          };
          this.users.push(userCredentials);
        });

        this.lastUserLoaded =
          dataBaseResultsUser.docs[dataBaseResultsUser.docs.length - 1];

        if (dataBaseResultsUser.empty) {
          this.$toast("End Of User List");
        }
      }

      if (this.showOrders) {
        const dataBaseOrder = await db
          .collection("orders")
          .orderBy("orderTime")
          .startAfter(this.lastOrderLoaded)
          .limit(10);

        const dataBaseResultsOrder = await dataBaseOrder.get();
        dataBaseResultsOrder.docs.forEach((order) => {
          const orderData = order.data();
          const orderCredentials = {
            id: order.id,
            restaurantName: orderData.restaurantName,
            userName: orderData.userName,
            date: orderData.orderTime,
            totalPrice: orderData.totalPrice,
            saviourName: orderData.saviourName,
            acceptedBySaviour: orderData.acceptedBySaviour,
            delivered: orderData.delivered,
            cancelled: orderData.cancelled,
          };
          this.orders.push(orderCredentials);
        });

        this.lastOrderLoaded =
          dataBaseResultsOrder.docs[dataBaseResultsOrder.docs.length - 1];

        if (dataBaseResultsOrder.empty) {
          this.$toast("End Of Orders List");
        }
      }

      if (this.showRestaurants) {
        const dataBaseRestaurant = await db
          .collection("restaurants")
          .orderBy("name")
          .startAfter(this.lastRestaurantLoaded)
          .limit(15);

        const dataBaseResultsRestaurant = await dataBaseRestaurant.get();
        dataBaseResultsRestaurant.docs.forEach((restaurant) => {
          const restaurantData = restaurant.data();
          const restaurantCredentials = {
            id: restaurant.id,
            name: restaurantData.name,
            location: restaurantData.location,
          };
          this.restaurants.push(restaurantCredentials);
        });

        this.lastRestaurantLoaded =
          dataBaseResultsRestaurant.docs[
            dataBaseResultsRestaurant.docs.length - 1
          ];

        if (dataBaseResultsRestaurant.empty) {
          this.$toast("End Of Restaurants List");
        }
      }
    },
  },
  async mounted() {
    // Retrieving User Data
    const dataBaseUser = await db
      .collection("users")
      .orderBy("firstName")
      .startAfter(0)
      .limit(15);

    const dataBaseResultsUser = await dataBaseUser.get();
    dataBaseResultsUser.docs.forEach((user) => {
      const userData = user.data();
      const userCredentials = {
        id: user.id,
        name: userData.firstName + " " + userData.lastName,
        username: userData.username,
        email: userData.email,
        phoneNumber: userData.phoneNumber,
        admin: userData.admin,
      };
      this.users.push(userCredentials);
    });
    this.lastUserLoaded =
      dataBaseResultsUser.docs[dataBaseResultsUser.docs.length - 1];

    this.pageLoading = false;

    // Retrieving Order Data
    const dataBaseOrder = await db
      .collection("orders")
      .orderBy("orderTime")
      .startAfter(0)
      .limit(10);

    const dataBaseResultsOrder = await dataBaseOrder.get();
    dataBaseResultsOrder.docs.forEach((order) => {
      const orderData = order.data();
      const orderCredentials = {
        id: order.id,
        restaurantName: orderData.restaurantName,
        userName: orderData.userName,
        date: orderData.orderTime,
        totalPrice: orderData.totalPrice,
        saviourName: orderData.saviourName,
        acceptedBySaviour: orderData.acceptedBySaviour,
        delivered: orderData.delivered,
        cancelled: orderData.cancelled,
      };
      this.orders.push(orderCredentials);
    });
    this.lastOrderLoaded =
      dataBaseResultsOrder.docs[dataBaseResultsOrder.docs.length - 1];

    // Retreiving Restaurants Data
    const dataBaseRestaurant = await db
      .collection("restaurants")
      .orderBy("name")
      .startAfter(0)
      .limit(15);

    const dataBaseResultsRestaurant = await dataBaseRestaurant.get();
    dataBaseResultsRestaurant.docs.forEach((restaurant) => {
      const restaurantData = restaurant.data();
      const restaurantCredentials = {
        id: restaurant.id,
        name: restaurantData.name,
        location: restaurantData.location,
      };
      this.restaurants.push(restaurantCredentials);
    });
    this.lastRestaurantLoaded =
      dataBaseResultsRestaurant.docs[dataBaseResultsRestaurant.docs.length - 1];
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;

  .header {
    flex-basis: 30%;
    text-align: center;
    margin-top: 10px;
    font-size: 36px;

    .buttons {
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      @media (min-width: 800px) {
        flex-direction: row;
      }

      .view {
        margin: 0 20px;
      }

      button {
        min-width: 150px;

        &:hover {
          cursor: pointer;
        }
      }
    }
  }

  .body {
    flex-basis: 70%;
    border: 2px solid black;
    overflow: auto;
    margin: 20px;
    min-height: 80vh;
    min-width: 90vw;

    @media (min-width: 800px) {
      min-width: 95vw;
    }

    display: flex;
    flex-direction: column;

    .data {
      flex-basis: 95%;

      .users {
        text-align: center;

        .users-top-bar {
          display: flex;
          flex-direction: column;
          padding: 15px 5px;
          margin: 0px 5px 5px 5px;
          border-bottom: 6px solid #000;
          //gap: 16px;

          @media (min-width: 800px) {
            flex-direction: row;
          }

          .user-id {
            display: flex;
            justify-content: center;
            flex-basis: 20%;
          }

          .full-name {
            display: flex;
            justify-content: center;
            flex-basis: 25%;
          }

          .username {
            display: flex;
            justify-content: center;
            flex-basis: 15%;
          }

          .email {
            display: flex;
            justify-content: center;
            flex-basis: 20%;
          }

          .phone-number {
            display: flex;
            justify-content: center;
            flex-basis: 20%;
          }
        }
      }

      .orders {
        text-align: center;

        .orders-top-bar {
          display: flex;
          //gap: 16px;
          margin: 0 5px;
          margin-bottom: 6px;
          //background-color: #f1f1f1;
          border-bottom: 6px solid #000;
          //border-radius: 8px;
          padding: 18px 20px;
          align-items: center;
          flex-direction: column;

          @media (min-width: 800px) {
            flex-direction: row;
          }

          .order-id {
            display: flex;
            justify-content: center;
            flex-basis: 15%;
          }

          .full-name {
            display: flex;
            justify-content: center;
            flex-basis: 15%;
          }

          .restaurant-name {
            display: flex;
            justify-content: center;
            flex-basis: 15%;
          }

          .time {
            display: flex;
            justify-content: center;
            flex-basis: 15%;
          }

          .price {
            display: flex;
            justify-content: center;
            flex-basis: 10%;
          }

          .saviour-name {
            display: flex;
            justify-content: center;
            flex-basis: 15%;
          }

          .order-status {
            display: flex;
            justify-content: center;
            flex-basis: 15%;
          }
        }
      }

      .restaurants {
        text-align: center;

        .restaurants-top-bar {
          display: flex;
          flex-direction: column;
          border-bottom: 6px solid #000;
          padding: 15px 5px;
          margin: 0 5px 5px 5px;

          @media (min-width: 800px) {
            flex-direction: row;
          }

          .restaurant-id {
            display: flex;
            justify-content: center;
            flex-basis: 33%;
          }

          .restaurant-name {
            display: flex;
            justify-content: center;
            flex-basis: 34%;
          }

          .restaurant-location {
            display: flex;
            justify-content: center;
            flex-basis: 33%;
          }
        }
      }
    }

    .load-more {
      margin: 0 auto;
      margin-bottom: 10px;
      flex-basis: 5%;
    }
  }
}
</style>
